import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

/** @type {import('./index').Header} */
const Header = ({ title, className }) => (
    <div className={classnames(styles.header, className, 'm-b-12 text-bold co-text-darker')}>{title}</div>
);

/** @type {import('./index').ContentsWrapper} */
const ContentsWrapper = ({ className, children }) => (
    <div className={classnames(className, styles.contentsWrapper, 'flex flex-col')}>{children}</div>
);

/** @type {import('./index').Content} */
const Content = ({ icon, subtitle, title, description, subtitleClassName, titleClassName, descriptionClassName }) => (
    <div className={classnames(styles.content, 'flex flex-items-start')}>
        {icon}
        <div
            className={classnames(styles.info, {
                [styles.withIcon]: !!icon,
            })}
        >
            <div className={classnames(styles.title, titleClassName, 'tbody-6', 'text-semi-bold')}>{title}</div>
            {subtitle && <div className={classnames(styles.subtitle, subtitleClassName, 'tbody-6')}>{subtitle}</div>}
            {description && (
                <div className={classnames(styles.description, descriptionClassName, 'tbody-6')}>{description}</div>
            )}
        </div>
    </div>
);

export { Header, ContentsWrapper, Content };
